import { render, staticRenderFns } from "./courseTable.vue?vue&type=template&id=0e10a581&scoped=true&"
import script from "./courseTable.vue?vue&type=script&lang=js&"
export * from "./courseTable.vue?vue&type=script&lang=js&"
import style0 from "./courseTable.vue?vue&type=style&index=0&id=0e10a581&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e10a581",
  null
  
)

export default component.exports